// NOTE: These map to the runtime CSS custom properties published by
// applyThemeColors() (see src/helpers/applyThemeColors.ts). The value inside
// each var() is the default ("current") theme used before the mobile-app
// colors endpoint responds or if it fails.
const primaryColors = {
  white: "var(--color-primary, #ffffff)",
  black: "var(--color-secondary, #000000)",
  orange: "var(--color-tertiary, #ff6500)",
};

const whiteShades = {
  shade1: "var(--white-shade-1, #b2b2b2)",
  shade2: "var(--white-shade-2, #808080)",
  shade3: "var(--white-shade-3, #666666)",
  shade4: "var(--white-shade-4, #4d4d4d)",
};

const orangeShades = {
  shade1: "var(--orange-shade-1, #b24700)",
  shade2: "var(--orange-shade-2, #803300)",
  shade3: "var(--orange-shade-3, #662800)",
  shade4: "var(--orange-shade-4, #4d1e00)",
};

const buttonWhite = {
  contained: {
    font: primaryColors.black,
    background: primaryColors.white,
    backgroundHover: whiteShades.shade1,
    backgroundActive: whiteShades.shade2,
    backgroundDisabled: whiteShades.shade3,
  },
  outlined: {
    font: primaryColors.white,
    background: "transparent",
    border: whiteShades.shade1,
    backgroundHover: whiteShades.shade4,
    borderHover: primaryColors.white,
    backgroundActive: whiteShades.shade2,
    borderActive: primaryColors.white,
    fontDisabled: whiteShades.shade3,
    borderDisabled: whiteShades.shade2,
  },
  text: {
    background: "transparent",
    font: primaryColors.white,
    fontHover: whiteShades.shade1,
    fontActive: whiteShades.shade2,
    fontDisabled: whiteShades.shade3,
  },
};

const buttonOrange = {
  contained: {
    font: primaryColors.black,
    background: primaryColors.orange,
    backgroundHover: orangeShades.shade1,
    backgroundActive: orangeShades.shade2,
    backgroundDisabled: orangeShades.shade3,
  },
  outlined: {
    font: primaryColors.orange,
    background: "transparent",
    border: orangeShades.shade1,
    backgroundHover: orangeShades.shade4,
    borderHover: primaryColors.orange,
    backgroundActive: orangeShades.shade2,
    borderActive: primaryColors.orange,
    fontDisabled: orangeShades.shade3,
    borderDisabled: orangeShades.shade2,
  },
  text: {
    background: "transparent",
    font: primaryColors.orange,
    fontHover: orangeShades.shade1,
    fontActive: orangeShades.shade2,
    fontDisabled: orangeShades.shade3,
  },
};

const transparentColors = {
  transparent: "rgba(0, 0, 0, 0)",

  whiteShade1: "var(--transparent-white-1, rgba(255, 255, 255, 0.1))",
  whiteShade2: "var(--transparent-white-2, rgba(255, 255, 255, 0.2))",
  whiteShade3: "var(--transparent-white-3, rgba(255, 255, 255, 0.3))",
  whiteShade4: "var(--transparent-white-4, rgba(255, 255, 255, 0.4))",
  whiteShade5: "var(--transparent-white-5, rgba(255, 255, 255, 0.5))",
  whiteShade6: "var(--transparent-white-6, rgba(255, 255, 255, 0.6))",

  blackShade1: "var(--transparent-black-1, rgba(0, 0, 0, 0.1))",
  blackShade2: "var(--transparent-black-2, rgba(0, 0, 0, 0.2))",
  blackShade3: "var(--transparent-black-3, rgba(0, 0, 0, 0.3))",
  blackShade4: "var(--transparent-black-4, rgba(0, 0, 0, 0.4))",
  blackShade5: "var(--transparent-black-5, rgba(0, 0, 0, 0.5))",
  blackShade6: "var(--transparent-black-6, rgba(0, 0, 0, 0.6))",

  orangeShade1: "var(--transparent-orange-1, rgba(255, 101, 0, 0.1))",
  orangeShade2: "var(--transparent-orange-2, rgba(255, 101, 0, 0.2))",
  orangeShade3: "var(--transparent-orange-3, rgba(255, 101, 0, 0.3))",
  orangeShade4: "var(--transparent-orange-4, rgba(255, 101, 0, 0.4))",
  orangeShade5: "var(--transparent-orange-5, rgba(255, 101, 0, 0.5))",
  orangeShade6: "var(--transparent-orange-6, rgba(255, 101, 0, 0.6))",
};

const iconButtonWhite = {
  font: primaryColors.black,
  background: primaryColors.white,
  backgroundHover: whiteShades.shade1,
  backgroundActive: whiteShades.shade2,
};

const iconButtonBlack = {
  font: primaryColors.white,
  background: primaryColors.black,
  backgroundHover: transparentColors.blackShade6,
  backgroundActive: transparentColors.blackShade5,
};

const iconButtonBlackText = {
  font: primaryColors.black,
  background: transparentColors.transparent,
  fontHover: transparentColors.blackShade6,
  fontActive: transparentColors.blackShade5,
};

const iconButtonWhiteText = {
  font: primaryColors.white,
  background: transparentColors.transparent,
  fontHover: transparentColors.whiteShade6,
  fontActive: transparentColors.whiteShade5,
};

export {
  primaryColors,
  whiteShades,
  orangeShades,
  buttonWhite,
  buttonOrange,
  transparentColors,
  iconButtonWhite,
  iconButtonBlack,
  iconButtonBlackText,
  iconButtonWhiteText,
};
